import AllProducts from '../components/AllProducts'

const Products = () => {
  return (
    <div className="pt-20">
      <AllProducts />
    </div>
  )
}
export default Products
